export default (api) => {
  for(const callback of window.kernel.mockApi) {
    callback(api)
  }
}